import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ProductService } from 'app/services/models/product.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { CurrencyService } from 'app/services/models/currency.service';
import { BrandService } from 'app/services/models/brand.service';
import { UnitTypeService } from 'app/services/models/unit-type.service';
import { CategoryService } from 'app/services/models/category.service';
import { WarehouseService } from 'app/services/models/warehouse.service';

@Component({
  selector: 'app-product-list',
  templateUrl: './product-list.component.html',
  styleUrls: ['./product-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProductListComponent implements OnInit {
  isPrice: boolean = true;
  constructor(
    private productService: ProductService,
    private router: Router,
    private currencyService: CurrencyService,
    private brandService: BrandService,
    private unitTypeService: UnitTypeService,
    private categoryService: CategoryService,
    private warehouseService: WarehouseService) { }

  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  public ColumnMode = ColumnMode;

  isFilter: boolean = false;

  isFilterPanelOpen = false;
  async ngOnInit() {
    await this.getAllProducts(this.pageBasic - 1, this.selectedSize, this.searchValue, this.brandModelId, this.brandId, this.unitTypeId, this.categoryId, this.currencyId, this.warehouseId);
    await this.getAllCategory();
    await this.getAllUnitType();
    await this.getAllBrandModel();
    await this.getAllCurrency();
    await this.getAllBrands();
    await this.getAllWarehouses();
  }

  toggleFilterPanel() {
    this.isFilterPanelOpen = !this.isFilterPanelOpen;
  }

  priceElevation() {
    this.isPrice = !this.isPrice;
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;
    setTimeout(async () => {

      await this.getAllProducts(this.pageBasic - 1, this.selectedSize, this.searchValue, this.brandModelId, this.brandId, this.unitTypeId, this.categoryId, this.currencyId, this.warehouseId);
    }, 500);
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {

      this.router.navigate([`/admin/detail-product/${event.row.id}`]);
    }
  }

  getFormattedLength(labels): string {
    const length = labels.length - 1;
    return length > 1 ? `(+${length})` : '';
  }

  async getAllProducts(page, size, seacrh, brandModelId?: number, brandId?: number, unitTypeId?: number, categoryId?: number, currencyId?: number, warehouseId?: number): Promise<any> {
    this.blockUI.start()
    try {
      const data = await this.productService.getAllProducts(page, size, seacrh, brandModelId, brandId, unitTypeId, categoryId, currencyId, warehouseId);
      this.rows = data.products;
      console.log(data);
      this.totalCount = data.totalCount;
    } catch (error) {
    }
    this.blockUI.stop()
  }

  async onPageChange(pageNumber: number) {
    await this.getAllProducts(this.pageBasic - 1, this.selectedSize, this.searchValue, this.brandModelId, this.brandId, this.unitTypeId, this.categoryId, this.currencyId, this.warehouseId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllProducts(this.pageBasic - 1, this.selectedSize, this.searchValue, this.brandModelId, this.brandId, this.unitTypeId, this.categoryId, this.currencyId, this.warehouseId);
  }

  async exportExcel() {
    await this.getAllProducts(0, 1000, '');
    const exportedData = [];
    this.rows.forEach(item => {
      const rowData = {
        'Ürün Adı': item.name,
        'Satış Fiyatı': item.salePrice ?? 0,
        'Alış Fiyatı': item.purchasePrice ?? 0,
        'Marka': item.brandName ?? 'Yok',
        'Model': item.brandModelName ?? 'Yok',
        'Para Birimi': item.currencyName,
        'Ürün Tipi': item.productType ? 'Ürün' : 'Hizmet'
      };
      exportedData.push(rowData);
    });
    return exportedData;
  }

  async exportAsExcelFile() {
    const data = await this.exportExcel();
    if (data.length > 0) {
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
      const workbook: XLSX.WorkBook = { Sheets: { 'Sheet1': worksheet }, SheetNames: ['Sheet1'] };
      const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
      this.saveAsExcelFile(excelBuffer, 'urunlistesi.xlsx');
    } else { }
  }

  private saveAsExcelFile(buffer: any, baseFileName: string): void {
    const data: Blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    FileSaver.saveAs(data, baseFileName);
  }

  async clearFilters() {
    this.brandModelId = null;
    this.categoryId = null;
    this.unitTypeId = null;
    this.brandId = null;
    this.currencyId = null;
    this.warehouseId = null;
    await this.getAllProducts(this.pageBasic - 1, this.selectedSize, this.searchValue, this.brandModelId, this.brandId, this.unitTypeId, this.categoryId, this.currencyId, this.warehouseId);
  }

  categories: any[];
  unitTypes: any[];
  brandsModel: any[];
  currencies: any[];
  brands: any[];
  warehouses: any[];

  brandModelId = null;
  categoryId = null;
  unitTypeId = null;
  brandId = null;
  currencyId = null;
  warehouseId = null;

  searchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.name?.toLowerCase().includes(term) || item.brandName?.toLowerCase().includes(term);
  }

  async getAllWarehouses() {
    const data = await this.warehouseService.getAllWarehouses(0, 1000, '');
    console.log(data);
    this.warehouses = data.warehouses;
  }

  async getAllCategory() {
    const data = await this.categoryService.getAllCategory(0, 1000, '', 1);
    console.log(data);
    this.categories = data.categories;
  }

  async getAllUnitType() {
    const data = await this.unitTypeService.getAllUnitType(0, 1000, '');
    console.log(data);
    this.unitTypes = data.unitTypes;

  }

  async getAllBrandModel() {
    const data = await this.brandService.getBrands();
    console.log(data);
    this.brandsModel = data.flatMap(brand =>
      brand.brandModels.map(model => ({
        id: model.id,                // Modelin ID'sini ekliyoruz
        name: model.modelName,        // Model ismi
        brandName: brand.brandName    // Grup başlığı olarak marka ismi
      }))
    );

  }

  async getAllCurrency() {
    const data = await this.currencyService.getAllPageCurrency(0, 1000, '');
    console.log(data);
    this.currencies = data.currenies;
  }

  async getAllBrands() {
    const data = await this.brandService.getAllBrand(0, 1000, '');
    console.log(data);
    this.brands = data.brands;
  }

  async filterBrandModel(event) {
    console.log(event);
    this.brandModelId = event.id;

  }

  async filterCurrency(event) {
    this.currencyId = event.id;

  }

  async filterUnitType(event) {
    this.unitTypeId = event.id;

  }

  async filterBrand(event) {
    this.brandId = event.id;
  }

  async filterCategory(event) {
    this.categoryId = event.id
  }

  async filterWarehouse(event) {
    this.warehouseId = event.id;
  }

  async applyFilters() {
    await this.getAllProducts(this.pageBasic - 1, this.selectedSize, this.searchValue, this.brandModelId, this.brandId, this.unitTypeId, this.categoryId, this.currencyId, this.warehouseId);
    this.toggleFilterPanel(); // Paneli kapat
  }

}
